import { registerDe } from '../i18n/index.js';

registerDe({
  // mast and rail
  'Campaigns': 'Kampagnen',
  'segment personas feed sequences': 'Segment-Personas speisen die Sequenzen',
  'every draft is written from the person’s own record': 'jeder Entwurf entsteht aus dem Datensatz der Person',
  'you approve each one': 'Sie geben jeden einzeln frei',
  'of': 'von',
  'left this hour': 'in dieser Stunde übrig',
  'Run tick now': 'Lauf jetzt starten',
  'Running…': 'Läuft…',
  'New sequence': 'Neue Sequenz',
  'Personas': 'Personas',
  'segment': 'Segment',
  'held person personas': 'übernommene Personen-Personas',
  'the campaigns service did not answer': 'der Kampagnendienst hat nicht geantwortet',
  'Sequences': 'Sequenzen',
  'running': 'laufend',
  'draft': 'Entwurf',
  'active enrolments': 'aktive Teilnahmen',
  'Drafts waiting': 'Wartende Entwürfe',
  'step': 'Schritt',
  'held in Review, never sent from here': 'in der Prüfung gehalten, von hier nie versendet',
  'nothing waiting for a decision': 'nichts wartet auf eine Entscheidung',
  'Sent · 7d': 'Gesendet · 7 T',
  'approved, waiting in the outbox': 'freigegeben, im Postausgang',
  'the outbox could not be read': 'der Postausgang konnte nicht gelesen werden',
  'Reply rate · 12m': 'Antwortquote · 12 M',
  'too few to say': 'zu wenige für eine Aussage',
  'sent': 'gesendet',
  'replied': 'geantwortet',
  'a rate needs {n}': 'eine Quote braucht {n}',

  // sequences zone
  'a step drafts; it never sends': 'ein Schritt entwirft; er versendet nie',
  '{cap} per hour across every campaign · {used} used': '{cap} pro Stunde über alle Kampagnen · {used} verbraucht',
  'Name': 'Name',
  'Autumn 2026 · AI governance': 'Herbst 2026 · KI-Governance',
  'Daily cap': 'Tageslimit',
  'Step': 'Schritt',
  'Wait · days': 'Wartezeit · Tage',
  'Subject': 'Betreff',
  'end here if no reply': 'hier enden, wenn keine Antwort kommt',
  'Template — {{first_name}}, {{organisation}} and {{role_title}} are filled from the record':
    'Vorlage — {{first_name}}, {{organisation}} und {{role_title}} werden aus dem Datensatz gefüllt',
  'Add step': 'Schritt hinzufügen',
  'Create as draft': 'Als Entwurf anlegen',
  'The steps could not be read.': 'Die Schritte konnten nicht gelesen werden.',
  'Could not create the sequence.': 'Die Sequenz konnte nicht erstellt werden.',
  'A new sequence is created as a draft and enrols nobody. Starting it makes its steps due; each due step files a draft proposal under the principal journey:SEQ-…, which you hold in Review and send from the Inbox.':
    'Eine neue Sequenz entsteht als Entwurf und nimmt niemanden auf. Beim Start werden ihre Schritte fällig; jeder fällige Schritt legt einen Entwurfsvorschlag unter dem Principal journey:SEQ-… an, den Sie in der Prüfung übernehmen und aus dem Posteingang versenden.',
  'loading…': 'lädt…',
  'No sequence yet': 'Noch keine Sequenz',
  'A sequence is a list of steps with a wait, a subject and a template. It drafts; it never sends.':
    'Eine Sequenz ist eine Liste von Schritten mit Wartezeit, Betreff und Vorlage. Sie entwirft; sie versendet nie.',
  'Ref': 'Ref',
  'Status': 'Status',
  'Steps': 'Schritte',
  'Enrolled': 'Aufgenommen',
  'Cap': 'Limit',
  '/d': '/T',
  'Start': 'Starten',
  'Pause': 'Pausieren',
  'Resume': 'Fortsetzen',
  'End': 'Beenden',
  'Enrol': 'Aufnehmen',
  '{ref} is now {status}': '{ref} ist jetzt {status}',
  'ended': 'beendet',
  'Could not change the sequence.': 'Die Sequenz konnte nicht geändert werden.',
  '{ref} created as a draft. Enrol people, then start it.':
    '{ref} als Entwurf angelegt. Nehmen Sie Personen auf und starten Sie dann.',

  // the selected sequence
  'Sequence': 'Sequenz',
  '{status} · step {n} of {total}': '{status} · Schritt {n} von {total}',
  'daily cap {cap} · {suppressed} suppressed · replies thread into the Inbox':
    'Tageslimit {cap} · {suppressed} gesperrt · Antworten laufen in den Posteingang',
  'Subject and template': 'Betreff und Vorlage',
  'Drafts': 'Entwürfe',
  'Branch': 'Verzweigung',
  'mail': 'Mail',
  'day': 'Tag',
  'waiting in Review': 'wartet in der Prüfung',
  'reply stops it': 'eine Antwort beendet sie',
  'end': 'Ende',
  'reply': 'Antwort',
  'no_reply': 'keine Antwort',
  'Find people to enrol': 'Personen für die Aufnahme suchen',
  'name, organisation…': 'Name, Organisation…',
  'Search': 'Suchen',
  'Enrol {n}': '{n} aufnehmen',
  'Nobody matches.': 'Niemand passt.',
  'Do-not-contact, an open deal at negotiation or later, a reply already received and a risk signal in the last 14 days each suppress an enrolment with a reason you can read below.':
    'Kontaktsperre, ein offenes Geschäft ab der Verhandlung, eine bereits erhaltene Antwort und ein Risikosignal der letzten 14 Tage sperren eine Teilnahme — jeweils mit einer Begründung, die unten steht.',
  '{n} enrolled in {ref}': '{n} in {ref} aufgenommen',
  'Could not enrol.': 'Die Aufnahme ist fehlgeschlagen.',
  'The enrolments could not be read.': 'Die Teilnahmen konnten nicht gelesen werden.',
  'Nobody is enrolled. Enrol people; a sequence with no enrolment drafts nothing.':
    'Niemand ist aufgenommen. Nehmen Sie Personen auf; eine Sequenz ohne Teilnahme entwirft nichts.',
  'Person': 'Person',
  'Next': 'Nächster',
  'Why it stopped': 'Warum sie steht',
  'Stop': 'Anhalten',
  'suppressed': 'gesperrt',
  'stopped': 'angehalten',
  'completed': 'abgeschlossen',
  'paused': 'pausiert',

  // drafts and attribution
  'Drafts to approve': 'Entwürfe zur Freigabe',
  'each one names the sequence and the step that asked for it':
    'jeder nennt die Sequenz und den Schritt, der ihn verlangt hat',
  'Review →': 'Prüfung →',
  'The campaigns service did not answer, so nothing here was counted.':
    'Der Kampagnendienst hat nicht geantwortet, also wurde hier nichts gezählt.',
  'No draft is waiting. A running sequence files one per due step, inside working hours, up to its daily cap.':
    'Kein Entwurf wartet. Eine laufende Sequenz legt je fälligem Schritt einen an, innerhalb der Arbeitszeit und bis zum Tageslimit.',
  'Waiting': 'Wartend',
  'Where it is decided': 'Wo entschieden wird',
  'Review the drafts from {ref}': 'Die Entwürfe von {ref} prüfen',
  'holding one writes it to the outbox; sending is a second click in the Inbox':
    'Übernehmen schreibt in den Postausgang; Senden ist ein zweiter Klick im Posteingang',
  'Attribution · 12m': 'Zurechnung · 12 M',
  'a rate is shown only above 20 assignments': 'eine Quote erscheint erst ab 20 Zuweisungen',
  'The experiments could not be read.': 'Die Experimente konnten nicht gelesen werden.',
  'No experiment is running. An experiment assigns its variants round-robin to the drafts of one sequence and reads the outcome off replies and meetings.':
    'Kein Experiment läuft. Ein Experiment verteilt seine Varianten reihum auf die Entwürfe einer Sequenz und liest das Ergebnis aus Antworten und Treffen.',
  'Variable': 'Variable',
  'Variant': 'Variante',
  'n': 'n',
  'Replies': 'Antworten',
  'Meetings': 'Treffen',
  'Reply rate': 'Antwortquote',
  'hook': 'Aufhänger',
  'length': 'Länge',
  'tone': 'Ton',
  'timing': 'Zeitpunkt',
  'Tick: {status}': 'Lauf: {status}',
  'The tick could not be run.': 'Der Lauf konnte nicht gestartet werden.',
  'ok': 'ok',
  'failed': 'fehlgeschlagen',
  'skipped': 'übersprungen',
  'no_handler': 'kein Handler',
}, 'CampaignsPage');
